import useAgentData from '~/client/hooks/useAgentData';
import Carousel from '~/client/shared/Carousel';
import CarouselPlaceholder from '~/client/shared/LazyLoad/Placeholder/CaroulselPlaceholder';
import Stack from '~/client/shared/Stack';
import SectionTitle from '../TournamentSection/SectionTitle';

type Placeholder = { enabled: boolean; width?: number; height?: number };
type Props = {
  items: (React.JSX.Element | null)[];
  placeholder?: Placeholder;
  totalCount?: number;
  status?: TournamentStatus;
  reelClassName?: string;
  isHomeTournaments?: boolean;
  onlyMine?: boolean;
};

const CardSize = {
  mobile: {
    width: 242,
    height: 412,
  },
  desktop: {
    width: 572,
    height: 394,
  },
};

const TournamentCarousel: FC<Props> = ({
  items,
  placeholder,
  status,
  totalCount,
  reelClassName,
  isHomeTournaments,
  onlyMine,
}) => {
  const { isMobile } = useAgentData();
  const size =
    placeholder?.width ?? isMobile ? CardSize.mobile : CardSize.desktop;

  if (placeholder?.enabled) {
    return <CarouselPlaceholder reelClassName={reelClassName} {...size} />;
  }

  return (
    <Stack>
      <SectionTitle
        status={status}
        totalCount={totalCount}
        isHomeTournaments={isHomeTournaments}
        onlyMine={onlyMine}
      />
      <Stack>
        <Carousel step={2} reelClassName={reelClassName} items={items} />
      </Stack>
    </Stack>
  );
};

export default TournamentCarousel;
